import { ArrowBack } from "@mui/icons-material";
import { Button } from "@mui/material";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { AddressField } from '../components';

import { Label } from "../style";
import { sizes } from "../variables";
import { EmptyContainer } from "./style";

const Page404 = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  useEffect(() => {
    if (!pathname !== '404') navigate('/404');
  }, [])
  return (
    <EmptyContainer>
      <img src="/assets/logo.svg" width="10%" alt="Wallverse's logomark" />
      <Label fontFamily="Julius Sans One" fontSize={sizes.xl4} textAlign="center">
        There's a whole <span className="highlight">wallverse</span> out there
      </Label>
      <Label fontFamily="Julius Sans One" fontSize={sizes.xl2} textAlign="center">
        Start building your own!
      </Label>
      <AddressField />
      <Button color="primary" size="large" onClick={() => navigate('/about')} aria-label="Navigate to the about page">
        <ArrowBack sx={{ marginRight: sizes.xs2 }} />
        Learn more about wallverse
      </Button>
    </EmptyContainer>
  );
};

export default Page404;
